import React from 'react'
import { Header } from '../Typogaphy/Header'

export const BackgroundAuth = ({ children, isWholePage = false }) => {
  return (
    <div class={`h-screen p-4 w-full flex flex-col items-center ${isWholePage ? 'justify-start' : 'justify-center'} relative bg-white`}>
      {/*bg-gradient-to-r from-teal-300/25 via-gray-300/50 via-gray-300/50 to-teal-300/25*/}


      {children}


    </div>
  )
}
